import { Modal } from "@ab.uitools/ui-library/components/Modal";
import { Text } from "@ab.uitools/ui-library/components/Text";
import { useTranslation } from "react-i18next";

interface Props {
  onConfirm: () => void;
  onClose: () => void;
  isOpen: boolean;
  buttonText: string;
  isLoading?: boolean;
}

export const InsufficientFundsModal = ({
  onConfirm,
  onClose,
  isOpen,
  buttonText,
  isLoading,
}: Props) => {
  const { t } = useTranslation();
  return (
    <Modal
      onSubmit={onConfirm}
      titleProps={{
        title: t("updateYourBalance.title"),
        size: "large",
      }}
      isOpen={isOpen}
      onClose={onClose}
      buttonProps={{
        confirm: {
          buttonText: buttonText,
          buttonActionType: "submit",
          isLoading: isLoading,
          disabled: isLoading,
        },
        cancel: {
          buttonText: t("general.cancel"),
          disabled: isLoading,
        },
      }}
    >
      <div data-testid="insufficient-funds-modal">
        <Text>{t("updateYourBalance.description")}</Text>
      </div>
    </Modal>
  );
};
